export enum VVState {
  NOT_INITIALIZED = 'Não inicializado',
  INITIALIZED = 'Inicializado',
}
